import { styled } from '@material-ui/core'
import { Link as BaseLink } from 'react-router-dom'

export const Link = styled(BaseLink)({ textDecoration: 'none' })
